import { Rate, RateType } from './rate';

export class ServiceRate extends Rate {
    constructor() {
        super();
        this.type = RateType.Service;
    }
}
